import { Box, Button } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";

const CustomButton = ({
  id = "custom_button",
  size = "md",
  width = "100%",
  height = "52px",
  text = "",
  textColor = COLORS.WHITE_COLOR,
  borderRadius = "100px",
  bgColor = COLORS.THEME_COLOR,
  onPress = () => {},
  isDisabled = false,
  startIcon = "",
  endIcon = "",
  isOutline = false,
  mt = "",
  fontSize = COMMONFONTSIZE.MEDIUM_FONT_SIZE,
  fontWeight = COMMONFONTWEIGHT.LARGE_FONT_WEIGHT,
  pl=5,
  pr=5
}) => {
  const buttonStyle = {
    pl: pl,
    pr: pr,
    size,
    width,
    height,
    onPress,
    isDisabled,
    _text: {
      color: textColor,
      fontWeight: isOutline ? "bold" : "normal",
    },
    startIcon,
    endIcon,
  };

  if (isOutline) {
    buttonStyle.borderWidth = 1;
    buttonStyle.bgColor = "transparent";
    buttonStyle.borderColor = bgColor;
    buttonStyle._text.color = textColor;
    buttonStyle.borderRadius = "100px";
  } else {
    buttonStyle.bgColor = bgColor;
    buttonStyle.borderRadius = borderRadius;
    buttonStyle._text.fontSize = fontSize;
    buttonStyle._text.fontWeight = fontWeight;
    buttonStyle._text.color = textColor;
  }

  return (
    <Box mt={mt}>
      <Button id={id} {...buttonStyle}>
        {text}
      </Button>
    </Box>
  );
};

export default CustomButton;
